import { Drawer } from 'antd';
import Layout from 'antd/es/layout';
import { Content } from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import { useCallback, useLayoutEffect, useState } from "react";
import SideMenu from '../SideMenu/SideMenu';
// import ViewAddons from '../viewAddons/viewAddons';
import './styles.css';
import useDevice from '../../../../hooks/useDevice';
import { Outlet } from 'react-router-dom';
import ViewAddons from '../ViewAddons/ViewAddons';

export const CONTAINER_ID = 'body';

const WLayout = () => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const { isSmartphone } = useDevice();

    useLayoutEffect(() => {
        const anchor = document.getElementById('anchor');
        if (anchor) anchor.scrollIntoView();
    });

    const toggleOpenDrawer = useCallback(() => setOpenDrawer(!openDrawer), [openDrawer]);

    return (
        <Layout className={`__layout collapsed ${isSmartphone ? 'mobile' : ''}`}>
            {
                !isSmartphone &&
                <Sider className='__layout-sider' collapsed={true}>
                    <SideMenu />
                </Sider>
            }
            {
                isSmartphone &&
                <Drawer
                    className='__sidemenu-mobile-drawer'
                    placement="right"
                    closable={false}
                    onClose={toggleOpenDrawer}
                    open={openDrawer}
                >
                    <SideMenu onRouteChange={toggleOpenDrawer} />
                </Drawer>
            }
            <Content className={`__layout-content`}>
                <ViewAddons setOpenDrawer={setOpenDrawer}>
                    <Outlet />
                </ViewAddons>
            </Content>
        </Layout>

    );
};

export default WLayout;